/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Who3_DescInputs */

const en_dr_who3_desc = /** @type {(inputs: Dr_Who3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The capstone template starts from the problem owner, not a blank proposal. The advisor grades the process — cards and votes — not just the final report.`)
};

const id_dr_who3_desc = /** @type {(inputs: Dr_Who3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Template capstone dimulai dari pemilik masalah, bukan proposal kosong. Dosen menilai proses — kartu dan suara — bukan hanya laporan akhir.`)
};

/**
* | output |
* | --- |
* | "The capstone template starts from the problem owner, not a blank proposal. The advisor grades the process — cards and votes — not just the final report." |
*
* @param {Dr_Who3_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_who3_desc = /** @type {((inputs?: Dr_Who3_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Who3_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_who3_desc(inputs)
	return en_dr_who3_desc(inputs)
});